import { UserInterface } from "../interfaces/UserInterface";

export const getUserFullName = (user?: UserInterface): string | null => {
    if (!user) return null;

    return `${user.first_name} ${user.insertion ?? ""} ${user.last_name}`;
};
